import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { addressResultToPath } from 'shared/utilities/routeUtils'

import './style.scss'

// https://github.com/NYCPlanning/labs-geosearch-docker/blob/master/MIGRATING.md

// Splits label into parts and wraps the matching portion in <strong> so the
// text the user typed is visually highlighted in each result row.
const highlightMatch = (label, query) => {
  if (!query || !query.trim()) return label
  const words = query.trim().split(/\s+/).filter(Boolean)
  const escaped = words.map(w => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
  // Try full phrase first (preserves space between words), then individual words
  const fullPhrase = escaped.join('\\s+')
  const pattern = new RegExp(`(${[fullPhrase, ...escaped].join('|')})`, 'i')
  const parts = label.split(pattern)
  const isMatch = part => new RegExp(`^(${[fullPhrase, ...escaped].join('|')})$`, 'i').test(part)
  return parts.map((part, i) =>
    isMatch(part)
      ? <span key={i} className="highlighted-result" style={{backgroundColor: '#ffc80063'}}>{part}</span>
      : i === parts.length - 1
        ? <span key={i} className="non-highlighted-result end-result">{part}</span>
        : <span key={i} className="non-highlighted-result">{part}</span>
  )
}

const SearchResultRow = props => {
  const { result } = props
  if (result.label) {
    return (
      <Link
        role="button"
        ref={props.currentResultFocusRef}
        tabIndex={0}
        className="search-result-row d-flex"
        onKeyDown={props.onKeyDown}
        onFocus={() => props.setResultFocusIndex(props.resultIndex)}
        // onClick={e => props.onClick(e, result)}
        to={addressResultToPath({ bbl: result.addendum.pad.bbl, bin: result.addendum.pad.bin })}
      >
        <span>{highlightMatch(result.label, props.searchValue)}</span>
      </Link>
    )
  } else {
    return (
      <div className="search-result-row no-result">
        <span>No results.</span>
      </div>
    )
  }
}

SearchResultRow.propTypes = {
  selectBuildingResult: PropTypes.func,
  dispatch: PropTypes.func,
  onClick: PropTypes.func,
  result: PropTypes.object,
  resultIndex: PropTypes.number,
  setResultFocusIndex: PropTypes.func,
}

export default SearchResultRow
